import { AxiosError } from 'axios';

import { FEATURELOCKS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { FeatureLocks } from '@/types/feature.locks.type';
import { ApiResponse } from '@/types/response.type';

export const getFeatureLocks = async (): Promise<ApiResponse<FeatureLocks>> => {
  try {
    const response = await apiManager.get(FEATURELOCKS_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
